import Dashboard from '../container/dashboard/Dashboard';
function HomePage() {
  return <Dashboard />;
}
export default HomePage;
